export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const UPDATE_EXPENSE = 'UPDATE_EXPENSE'
export const GET_DATA = 'GET_DATA';